module.exports = "{\n  \"khlis\": \"v1/daan/khlis/\",\n  \"timeout\": 60000\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/appSetting.json
// module id = bcJV
// module chunks = 2